import { defineAsyncComponent, toRaw } from "vue";
import { GatingTimeWindow } from "@/generated/graphql";
import type { AuthorizationRuleForGatingInput } from "../use-gating-rule-conversion";
import type {
  CriterionApplyContext,
  GatingCriterionTypeDefinition,
} from "./gating-criterion-type";
import { GatingStrategyType } from "../strategies/gating-strategy";

export const pointsCriterionType: GatingCriterionTypeDefinition = {
  presetId: "points_threshold",
  classificationKey: GatingStrategyType.points,
  capabilityKey: "canUsePointsGating",

  labelKey: "channel.gating.builder.presets.pointsThreshold.label",
  descriptionKey: "channel.gating.builder.presets.pointsThreshold.description",
  icon: "material-symbols:leaderboard",
  columnHeaderKey: "channel.gating.builder.featureRows.minPointsNeeded",

  hasCriterion(rule: AuthorizationRuleForGatingInput): boolean {
    return !!rule.points_criterion;
  },

  isGated(rule: AuthorizationRuleForGatingInput): boolean {
    return !!rule.points_criterion;
  },

  applyDefaults(
    rule: AuthorizationRuleForGatingInput,
    _context: CriterionApplyContext,
  ): void {
    rule.points_criterion = {
      min_points: 1,
      time_window: GatingTimeWindow.AllTime,
      community_id: undefined,
    };
  },

  clearCriterion(rule: AuthorizationRuleForGatingInput): void {
    rule.points_criterion = undefined;
  },

  copyCriterion(
    source: AuthorizationRuleForGatingInput,
    target: AuthorizationRuleForGatingInput,
  ): void {
    target.points_criterion = source.points_criterion
      ? structuredClone(toRaw(source.points_criterion))
      : undefined;
  },

  criterionEquals(
    a: AuthorizationRuleForGatingInput,
    b: AuthorizationRuleForGatingInput,
  ): boolean {
    return (
      JSON.stringify(a.points_criterion) === JSON.stringify(b.points_criterion)
    );
  },

  serializeCriterion(rule: AuthorizationRuleForGatingInput): unknown {
    return rule.points_criterion;
  },

  expandedLayout: "below",

  indeterminatePlaceholder: defineAsyncComponent(
    () => import("../builder/components/points-indeterminate-placeholder.vue"),
  ),

  expandedValueEditor: defineAsyncComponent(
    () => import("../builder/components/points-expanded-editor.vue"),
  ),
};
